import axiosInstance from '@/utils/api.js'

var state = {
  apiPermissions: []
}

var getters = {
  API_PERMISSIONS: (state) => {
    return state.apiPermissions
  }
}

var mutations = {
  SET_API_PERMISSIONS: (state, payload) => {
    state.apiPermissions = payload
  }
}

var actions = {
  GET_API_PERMISSIONS: async (context, payload) => {
    let result = await axiosInstance.get('/permissions')
    if (result.status === 200) {
      context.commit('SET_API_PERMISSIONS', result.data)
    }
  },
  CREATE_API_PERMISSIONS: (context, payload) => {
    return axiosInstance.post('/permissions?system_group_id=' + payload.groupID, payload.data)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/permissions.js